import React, { useState } from 'react';
import { CopyClipboardIcon as CopyIcon, CheckIcon } from '@tanium/react-graphics';
import { Box } from '@tanium/react-box';
import clipboardCopy from 'clipboard-copy';
import { useTheme } from '@tanium/react-theme-context';
import Logger from 'logger/Logger';
import Tooltip from 'components/tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { ICopyToClipboardProps } from './copyToClipboard';
import 'components/common/copyToClipboard/copyToClipboard.css';

interface IInlineCopyToClipboardProps extends ICopyToClipboardProps {
  tooltipContent?: string;
}

export const InlineCopyToClipboard: React.VFC<IInlineCopyToClipboardProps> = (props: IInlineCopyToClipboardProps) => {
  const [isActiveRequest, setIsActiveRequest] = useState(false);
  const logger = Logger.getLogger('InlineCopyToClipboard');
  const { t } = useTranslation();
  const theme = useTheme();

  const copyClicked = async () => {
    if (props.disabled) {
      return;
    }
    setIsActiveRequest(true);
    if (props.copyText) {
      try {
        await clipboardCopy(props.copyText);
      } catch (error) {
        logger.error((error as Error).message);
      }
    }
    // Resetting the button back to normal view
    /* istanbul ignore next */
    setTimeout(() => {
      setIsActiveRequest(false);
    }, 2500);
  };

  return (
    <Tooltip content={props.tooltipContent || t('COPY_TEXT')}>
      <Box
        onClick={copyClicked}
        style={{ cursor: 'pointer', transitionDuration: '0.5s' }}
        display="flex"
        flexGrow={1}
        px={'0.1em'}
        border={isActiveRequest ? '1px dotted rgba(0,255,45,0.95)' : '1px dotted rgba(0,0,0,0)'}
        borderRadius="0.5em"
        backgroundColor={isActiveRequest ? 'rgba(0,255,45,0.25)' : 'inherit'}
        alignItems="center"
      >
        {isActiveRequest ? (
          <Box>
            <CheckIcon
              style={{ paddingRight: 3, color: theme.colors.ActivePrimary }}
              width={props.iconSize?.width || 13}
              height={props.iconSize?.height || 13}
            />
          </Box>
        ) : (
          <Box>
            <CopyIcon
              style={{ paddingRight: 3, color: theme.colors.ActivePrimary }}
              width={props.iconSize?.width || 13}
              height={props.iconSize?.height || 13}
            />
          </Box>
        )}
        <Box className="truncated-text">{props.displayedText}</Box>
      </Box>
    </Tooltip>
  );
};

export default InlineCopyToClipboard;
